<div class="grid-border">
  <dx-data-grid
    #grid
    [dataSource]="dataSource"
    rowAlternationEnabled="true"
    [columnAutoWidth]="true"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    >
    <dxo-editing mode="cell" [allowUpdating]="editMode"></dxo-editing>

    <dxi-column dataField="bSelect" caption="" [visible]="editMode"></dxi-column>
    <dxi-column caption="" cellTemplate="includeRole" [visible]="!editMode" alignment="center"></dxi-column>
    <dxi-column dataField="role_name" caption="Role" [allowEditing]="false"></dxi-column>

    <div *dxTemplate="let data of 'includeRole'">
      @if (data.data.bSelect) {
        <img
          style="cursor: pointer;"
          src="{{ env.assetsPath }}images/Check Green Circle - 16x16.png"
          />
      }
    </div>
  </dx-data-grid>
</div>
